import { render, staticRenderFns } from "./ShopifyAppEmbedInstructions.vue?vue&type=template&id=6c5b3a3a"
import script from "./ShopifyAppEmbedInstructions.vue?vue&type=script&lang=js"
export * from "./ShopifyAppEmbedInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports